export default __webpack_public_path__ + "static/media/business-problem1-en.2e6aa969.png";